import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FieldChange } from './report-diff.service';


@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(
        private http: HttpClient,
  ) { 

  }

  sendEmail(username: string, reportID: string, tripID: string): Promise<boolean> {

    const url = environment.sendReportEmail;

    return new Promise<boolean>((res) => {

      this.http.post<any>(url, {username: username, report: reportID, trip: tripID}).subscribe(() => {
        res(true);
      }, (err: any) => {
        console.log(err);
        res(false);      
      });

    });

  }

  // attempts to send an email with a link to reset the specified user's password
  sendResetEmail(email: string): Observable<any> {

    const url = `${environment.sendInstantResponse}&username=${email}`;
    email = email.replace(/\+/g, "%2b");
    return this.http.get<any>(url);
    
  }

  sendEditNotification(payload: {
    fisherName: string;
    fin: string;
    vesselName: string;
    vrn: string;
    logbook: string;
    tripId: string;
    reportId: string;
    changedFields: FieldChange[];
  }): Observable<any> {
    const url = environment.sendEditNotificationEmail;
    return this.http.post<any>(url, payload);
  }

}
